/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetChatEnabledByOfferModel,
  IGetChatEnabledByOfferRequest,
  IMappers,
  IGetChatEnabledByOfferResponse,
  IGetChatEnabledByOfferResponseError,
  TGetChatEnabledByOfferResponse,
} from './types';

const defaultConfig: TGetChatEnabledByOfferModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'chats',
  pathApi: '/v1/get-chat-enabled-by-offer/',
  hostType: 'api',
} as TGetChatEnabledByOfferModel;

function createGetChatEnabledByOfferModel(parameters: IGetChatEnabledByOfferRequest): TGetChatEnabledByOfferModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetChatEnabledByOfferOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetChatEnabledByOfferRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetChatEnabledByOffer<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetChatEnabledByOfferOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetChatEnabledByOfferResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetChatEnabledByOfferModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetChatEnabledByOfferResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetChatEnabledByOfferResponseError);
    }
  }

  return { response, statusCode } as TGetChatEnabledByOfferResponse;
}

export { defaultConfig, createGetChatEnabledByOfferModel, fetchGetChatEnabledByOffer };
